import { HELP_FALLBACK_SCREEN_ID } from "@/config/helpRouteMatrix.js";

function normalizePath(pathname) {
  if (!pathname) return "/";
  return pathname.replace(/\/$/, "") || "/";
}

/**
 * Résolution écran d'aide contextualisée — BT-028-R1 (route → screenId précis).
 * @param {string} pathname
 */
export function resolveHelpScreenId(pathname) {
  const path = normalizePath(pathname);

  if (path === "/") return "public-home";
  if (path === "/accueil" || path.startsWith("/accueil/")) return "connected-home";
  if (path.startsWith("/changer-mot-de-passe")) return "change-password";
  if (path.startsWith("/connexion")) return "login";
  if (path.startsWith("/demande-compte")) return "account-request";
  if (path.startsWith("/devenir-membre")) return "become-member";
  if (path.startsWith("/calendrier")) return "public-calendar";
  if (path === "/black-dragon") return "public-black-dragon";
  if (path.startsWith("/a-propos")) return "a-propos";
  if (path.startsWith("/confidentialite")) return "confidentialite";
  if (path.startsWith("/contact")) return "contact";

  if (path.includes("/documents-preuves/import")) return "admin-documents-preuves-import";
  if (path.includes("/shotokan-black-dragon/documents-preuves")) return "admin-documents-preuves";
  if (path.startsWith("/admin/documents-preuves")) return "admin-documents-preuves";

  if (path.startsWith("/admin/shotokan-black-dragon")) return "admin-shotokan";
  if (path.startsWith("/sensei/shotokan-black-dragon")) return "sensei-shotokan";
  if (path.startsWith("/sempai/shotokan-black-dragon")) return "sempai-shotokan";

  if (path === "/admin" || path.endsWith("/admin/dashboard")) return "admin-dashboard";
  if (path === "/admin/lancement-1er-septembre") return "launch-cockpit";
  if (path === "/admin/instructeurs" || path === "/admin/instructors" || path === "/hanshi/instructeurs") {
    return "admin-instructors";
  }
  if (path === "/admin/dojos") return "admin-dojos";
  if (path === "/hanshi/membres" || path === "/admin/etudiants") return "admin-students";
  if (path === "/admin/assistants") return "admin-assistants";
  if (path === "/admin/parents") return "admin-parents";
  if (path.startsWith("/admin/presentation-interactive")) return "admin-presentation-interactive";
  if (path.startsWith("/admin/import")) return "admin-import";
  if (path.startsWith("/admin/documents")) return "admin-documents";
  if (path.startsWith("/admin/organisation")) return "admin-organisation";
  if (path.startsWith("/admin/classes")) return "admin-classes";
  if (path.startsWith("/admin/evenements")) return "admin-events";
  if (path.startsWith("/admin/presences")) return "admin-attendance";
  if (path.startsWith("/admin/progression") || path.startsWith("/admin/ceintures") || path.startsWith("/admin/examens")) {
    return "admin-progression";
  }
  if (path.startsWith("/admin/comptes")) return "admin-accounts";
  if (path.startsWith("/admin/diagnostic-avatar")) return "admin-diagnostic-avatar";
  if (path.startsWith("/admin/preparation-liste-officielle")) return "admin-official-list-prep";
  if (path.startsWith("/admin/roles")) return "admin-roles";
  if (path.startsWith("/admin/membres-officiels")) return "admin-official-members";
  if (path.startsWith("/admin/adhesions")) return "admin-membership";
  if (path.startsWith("/admin/black-dragon-adhesions")) return "admin-black-dragon-membership";
  if (path.startsWith("/admin/demandes")) return "admin-requests";
  if (path.startsWith("/admin/communications")) return "admin-communications";
  if (path.startsWith("/admin")) return "admin-dashboard";

  if (path.startsWith("/sensei")) return "sensei-dashboard";
  if (path.startsWith("/sempai")) return "sempai-dashboard";

  if (path.startsWith("/mes-informations")) return "mes-informations";

  if (path.startsWith("/mes-cours")) return "student-classes";
  if (path.startsWith("/mes-evenements")) return "student-events";
  if (path.startsWith("/ma-progression")) return "student-progress";
  if (path.startsWith("/mes-titres")) return "student-titles";
  if (path.startsWith("/mes-examens")) return "member-exams";
  if (path.startsWith("/mon-adhesion")) return "member-adhesion";
  if (path.startsWith("/mon-calendrier")) return "member-calendar";
  if (path.startsWith("/espace-black-dragon")) return "member-black-dragon";
  if (path.startsWith("/mes-documents")) return "student-documents";
  if (path.startsWith("/mon-espace") || path.startsWith("/mon-dojo") || path.startsWith("/mon-sensei")) {
    return "student-dashboard";
  }

  if (path.startsWith("/parent/adhesion")) return "parent-membership";
  if (path.startsWith("/parent/mes-enfants")) return "parent-children";
  if (path.startsWith("/parent/horaires")) return "parent-schedule";
  if (path.startsWith("/parent/evenements")) return "parent-events";
  if (path.startsWith("/parent/progression")) return "parent-progress";
  if (path.startsWith("/parent/documents")) return "parent-documents";
  if (path.startsWith("/parent/communications")) return "parent-comms";
  if (path.startsWith("/parent")) return "parent-dashboard";

  if (path.startsWith("/dojos")) return "dojos";
  if (path.startsWith("/instructeurs")) return "instructeurs";
  if (path.startsWith("/etudiants")) return "etudiants";
  if (path.includes("document") || path.includes("protocole")) return "documents";

  if (path.startsWith("/formation")) return "formation";
  if (path.startsWith("/aide")) return "aide";

  return HELP_FALLBACK_SCREEN_ID;
}

export function isHelpFallbackScreenId(screenId) {
  return screenId === HELP_FALLBACK_SCREEN_ID;
}
